import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../services/authContext';
import { Pane, Heading, Text, Button, Card, Avatar, TextInputField, majorScale, toaster, LogOutIcon, EditIcon, CrossIcon, TickIcon } from 'evergreen-ui';
import { changeDirectorPassword } from '../services/passwordService';
import UserDetailsForm from '../components/UserDetails/UserDetailsForm';

const ProfilePage = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const [showPasswordForm, setShowPasswordForm] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [isNarrow, setIsNarrow] = useState(typeof window !== 'undefined' ? window.innerWidth < 560 : false);

    useEffect(() => {
        const onResize = () => setIsNarrow(window.innerWidth < 560);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const handleLogout = () => {
        logout();
        navigate('/');
    };
    const handleToggleForm = () => {
        setShowPasswordForm(prev => !prev);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            toaster.danger('La nuova password e la conferma non corrispondono');
            return;
        }

        setLoading(true);
        try {
            const resp = await changeDirectorPassword(currentPassword, newPassword);
            if (resp && resp.success) {
                toaster.success('Password aggiornata con successo');
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
                setShowPasswordForm(false);
            } else {
                toaster.danger(resp.message || 'Errore durante l\'aggiornamento della password');
            }
        } catch (err) {
            console.error(err);
            toaster.danger('Errore di rete o del server');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Pane
            className="profile-container"
            margin="auto"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            padding={majorScale(3)}
            background="tint2"
            style={{ width: '95%', maxWidth: 900 }}
        >
            <Card
                elevation={3}
                background="white"
                padding={majorScale(4)}
                borderRadius={8}
                display="flex"
                flexDirection="column"
                alignItems="center"
                width="100%"
            >
                <Avatar name={user.email} size="4rem" marginBottom={24} fontSize="2rem" />
                <Heading size={600} marginBottom={16}>
                    Profilo utente
                </Heading>

                <Pane width="100%" marginBottom={8}>
                    <Text size={400}><strong>Email:</strong> {user.email}</Text>
                </Pane>

                <Pane width="100%" marginBottom={8}>
                    <Text size={400}><strong>Nome:</strong> {user.nome}</Text>
                </Pane>

                <Pane width="100%" marginBottom={8}>
                    <Text size={400}><strong>Cognome:</strong> {user.cognome}</Text>
                </Pane>

                <Pane width="100%" marginBottom={16}>
                    <Text size={400}><strong>Ruolo:</strong> {user.role === 'direttore' ? 'Direttore' : user.role === 'educatore' ? 'Educatore' : 'Operatore'}</Text>
                </Pane>

                <Pane display="flex" gap={8} width="100%" marginBottom={8} flexDirection={isNarrow ? 'column' : 'row'}>
                    <Button appearance="primary" intent="danger" onClick={handleLogout} flexBasis="auto" style={{ width: isNarrow ? '100%' : 'auto' }}>
                        <LogOutIcon marginRight={8} />Disconnetti
                    </Button>

                    {user.role === 'direttore' && (
                        <Button appearance="minimal" onClick={handleToggleForm} flexBasis="auto" style={{ width: isNarrow ? '100%' : 'auto' }}>
                            {showPasswordForm ? <><CrossIcon marginRight={8} />Annulla cambio password</> : <><EditIcon marginRight={8} />Cambia password</>}
                        </Button>
                    )}
                </Pane>

                {showPasswordForm && user.role === 'direttore' && (
                    <form style={{ width: '100%', marginTop: 12 }} onSubmit={handleSubmit}>
                        <TextInputField
                            label="Password corrente"
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            required
                        />

                        <TextInputField
                            label="Nuova password"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />

                        <TextInputField
                            label="Conferma nuova password"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />

                        <Button type="submit" appearance="primary" isLoading={loading} marginTop={8}>
                            <TickIcon marginRight={8} />Salva nuova password
                        </Button>
                    </form>
                )}
            </Card>

            <Card elevation={1} padding={majorScale(4)} background="white" width="100%" borderRadius={8} marginTop={majorScale(2)}>
                <UserDetailsForm userId={user.id} />
            </Card>
        </Pane>
    );
};

export default ProfilePage;